import React from 'react';

const Services = () => (
    <div>
        <h2>Previous Experience & Contributions</h2>
        <ul>
            <li>
                <strong>General Medical Consultation:</strong> Provided comprehensive assessments and personalized care plans for patients.
            </li>
            <li>
                <strong>Online COVID-19 Consultation:</strong> Expert guidance and treatment plans for mild-to-moderate COVID-19 cases under Apollo Kavach.
            </li>
            <li>
                <strong>Clinical Procedures:</strong> Proficient in venous/arterial blood sampling, IV cannula insertion, Foley’s catheter insertion, suturing, and minor surgical procedures.
            </li>
            {/*<li>*/}
            {/*    <strong>Radiology Expertise:</strong>*/}
            {/*    - Interpretation of diagnostic imaging such as X-rays, CT scans, and MRIs.*/}
            {/*    - Specialized training in interventional radiology techniques and image-guided procedures during PG residency at Kasturba Medical College, Manipal.*/}
            {/*</li>*/}
            <li>
                <strong>Health Check-Up Camps:</strong> Organizing free blood pressure and sugar level check-up camps for community welfare.
            </li>
            <li>
                <strong>Research and Academic Guidance:</strong> Mentoring medical students and guiding research projects to contribute to advancements in healthcare.
            </li>
            <li>
                <strong>Women’s Health Screenings:</strong> Conducting mini health check-ups for early detection of non-communicable diseases in women.
            </li>
            {/*<li>*/}
            {/*    <strong>Advanced Radiology Consultation:</strong> Offering expertise in diagnosing and managing complex cases using advanced imaging modalities.*/}
            {/*</li>*/}
        </ul>
    </div>
);

export default Services;
